export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10090.f5a4441e.jpg";